import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class newsletterPerformance_template extends vnTemplate{

    protected brandsFilter : multipleSelector_template;
    protected datesFilter: filterDate_template;
    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;
    public toolTipSubsDelta: infoButton_template;

    protected getTemplateHtml(): string{

        return  `
            <div class="sub-header w-justify">
                ` + this.presetFilter.getHtmlBuild() + `

                <div class="w-left">
                    ` + this.brandsFilter.getHtmlBuild() + `
                    ` + this.datesFilter.getHtmlBuild() + `
                    <div class="newsletter-esp-filter">
                        <label class="small" for="newsletter-esp-filter">ESP</label>
                        <select id="newsletter-esp-filter"
                                class="input-text"
                                data-bind="options: espOptions,
                                           optionsText: 'label',
                                           optionsValue: 'value',
                                           value: selectedEsp,
                                           event: { change: onEspChange }"></select>
                    </div>
                </div>
            </div>

            ` + this.validationsList.getHtmlBuild()  + `

             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-brands"></div>
                </div>
            </div>

            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-newsletter">Newsletter Performance</h2>
                </div>
                <div class="w-right">
                    <div class="highlight-page">
                        <div class="highlight-item">
                            <span class="item-title">Total Subscribers</span>
                            <strong class="item-value"><span data-bind="text: isNaN(totalSubscribers()) ? '-' : Number(totalSubscribers()).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"><span></strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-list-results" id="list-results" style="padding-bottom: 200px">

                <table class="list-results list-sections thin list-newsletter">
                    <thead>
                        <tr class="header">
                            <th colspan="1" class=""></th>
                            <th colspan="9" class="colgroup-1 start"><span>Newsletter</span></th>
                            <th colspan="6" class="colgroup-2 start"><span>Notifications</span></th>
                        </tr>
                        <tr class="sub-header">
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateData') }, css: { 'list-sort-desc': orderByAndDirection()=='dateData_DESC', 'list-sort-asc': orderByAndDirection()=='dateData_ASC' }" class="icon i-dropdown-simple">Date</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'campaignDeliveries') }, css: { 'list-sort-desc': orderByAndDirection()=='campaignDeliveries_DESC', 'list-sort-asc': orderByAndDirection()=='campaignDeliveries_ASC' }" class="icon i-dropdown-simple">Campaign <br> Deliveries</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sends') }, css: { 'list-sort-desc': orderByAndDirection()=='sends_DESC', 'list-sort-asc': orderByAndDirection()=='sends_ASC' }" class="icon i-dropdown-simple">Send Vol.</span></th>
                            <th data-bind=""><span class="icon list-sort-none no-wrap" data-bind="event: { click: onClickReorder.bind($data, 'deliveryRate') }, css: { 'list-sort-desc': orderByAndDirection()=='deliveryRate_DESC', 'list-sort-asc': orderByAndDirection()=='deliveryRate_ASC' }" class="icon i-dropdown-simple">Deliv. Rate</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'opens') }, css: { 'list-sort-desc': orderByAndDirection()=='opens_DESC', 'list-sort-asc': orderByAndDirection()=='opens_ASC' }" class="icon i-dropdown-simple">Opens</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'clicks') }, css: { 'list-sort-desc': orderByAndDirection()=='clicks_DESC', 'list-sort-asc': orderByAndDirection()=='clicks_ASC' }" class="icon i-dropdown-simple">Clicks</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'ctor') }, css: { 'list-sort-desc': orderByAndDirection()=='ctor_DESC', 'list-sort-asc': orderByAndDirection()=='ctor_ASC' }" class="icon i-dropdown-simple">CTOR</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'spamComplaints') }, css: { 'list-sort-desc': orderByAndDirection()=='spamComplaints_DESC', 'list-sort-asc': orderByAndDirection()=='spamComplaints_ASC' }" class="icon i-dropdown-simple">Spam Complaints</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'subs') }, css: { 'list-sort-desc': orderByAndDirection()=='subs_DESC', 'list-sort-asc': orderByAndDirection()=='subs_ASC' }" class="icon i-dropdown-simple">Sub/Unsub</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'subsDelta') }, css: { 'list-sort-desc': orderByAndDirection()=='campaignDeliveries_DESC', 'list-sort-asc': orderByAndDirection()=='subsDelta_ASC' }" class="icon i-dropdown-simple">Delta</span></th>
                            <th data-bind=""><span class="icon list-sort-none no-wrap" data-bind="event: { click: onClickReorder.bind($data, 'threadSends') }, css: { 'list-sort-desc': orderByAndDirection()=='sends_DESC', 'list-sort-asc': orderByAndDirection()=='sends_ASC' }" class="icon i-dropdown-simple">Send Vol.</span></th>
                            <th data-bind=""><span class="icon list-sort-none no-wrap" data-bind="event: { click: onClickReorder.bind($data, 'threadDeliveryRate') }, css: { 'list-sort-desc': orderByAndDirection()=='deliveryRate_DESC', 'list-sort-asc': orderByAndDirection()=='deliveryRate_ASC' }" class="icon i-dropdown-simple">Deliv. Rate</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'threadOpens') }, css: { 'list-sort-desc': orderByAndDirection()=='opens_DESC', 'list-sort-asc': orderByAndDirection()=='opens_ASC' }" class="icon i-dropdown-simple">Opens</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'threadClicks') }, css: { 'list-sort-desc': orderByAndDirection()=='clicks_DESC', 'list-sort-asc': orderByAndDirection()=='clicks_ASC' }" class="icon i-dropdown-simple">Clicks</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'threadCtor') }, css: { 'list-sort-desc': orderByAndDirection()=='ctor_DESC', 'list-sort-asc': orderByAndDirection()=='ctor_ASC' }" class="icon i-dropdown-simple">CTOR</span></th>
                            <th data-bind=""><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'threadSpamComplaints') }, css: { 'list-sort-desc': orderByAndDirection()=='spamComplaints_DESC', 'list-sort-asc': orderByAndDirection()=='spamComplaints_ASC' }" class="icon i-dropdown-simple">Spam Complaints</span></th>
                        </tr> 
                    </thead>
                    <tbody>

                    <!-- ko foreach: newsletterData -->
                        <tr class="not-total" data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                            <td><span class="no-wrap" data-bind="text: dateData"></span></td>
                            <td><span data-bind="text: Number(campaignDeliveries).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(sends).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(deliveryRate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td><span data-bind="text: Number(opens).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(clicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(ctor).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td><span data-bind="text: Number(spamComplaints).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(subs).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '/' + Number(unsubs).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(subsDelta).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(threadSends).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(threadDeliveryRate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td><span data-bind="text: Number(threadOpens).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(threadClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(threadCtor).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td><span data-bind="text: Number(threadSpamComplaints).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                        </tr>
                    <!-- /ko -->

                    <!-- ko foreach: newsletterTotalData -->
                        <tr class="total" data-bind="event: { click: $parent.onClickRowClick.bind($data, 'total' + $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf('total' + $index()) !== -1}">
                            <td data-bind="text: dateData"></td>
                            <td><span data-bind="text: Number(campaignDeliveries).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(sends).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(deliveryRate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td><span data-bind="text: Number(opens).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(clicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(ctor).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td><span data-bind="text: Number(spamComplaints).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(subs).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '/' + Number(unsubs).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(subsDelta).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(threadSends).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(threadDeliveryRate).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td><span data-bind="text: Number(threadOpens).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(threadClicks).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(threadCtor).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td><span data-bind="text: Number(threadSpamComplaints).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                        </tr>
                    <!-- /ko -->
                    </tbody>
                </table>
            </div>

            `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('newsletterPerformance');

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setLogoEnabled(true);

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 30);
        let endDate = new Date();
        this.datesFilter.setDateRange(startDate, endDate);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        let toolTipSubsDeltaContent = `
            <p>Calculated as Subscribers - Unsubscribers</p>
        `;
        this.toolTipSubsDelta = new infoButton_template('toolTipSubsDelta', this.getTemplateViewModel(), this.caller)
        this.toolTipSubsDelta.setTitle('Delta');
        this.toolTipSubsDelta.setContent(toolTipSubsDeltaContent);
    }

    protected getTemplateName(): string{

        return "newsletterPerformance_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            orderBy                                     : ko.observable("dateData")
            ,orderByDirection                           : ko.observable("ASC")
            ,orderByAndDirection                        : ko.observable("dateData_ASC")
            ,espOptions                                 : [
                { label: "All", value: "All" },
                { label: "Emaki", value: "Emaki" },
                { label: "Braze", value: "Braze" }
            ]
            ,selectedEsp                                : ko.observable("All")
            ,newsletterData                             : ko.observableArray([])
            ,newsletterTotalData                        : ko.observableArray([])
            ,totalSubscribers                           : ko.observable('-')
            ,selectedRows                               : ko.observableArray([])
            ,formatNumber                               : function(value){ return huit_neuf_this.formatNumber(value); }
            ,formatPercent                              : function(value){ return huit_neuf_this.formatPercent(value); }
            ,onEspChange                                : function(){ huit_neuf_this.caller.filterEspOnChange(); }
            ,onClickReorder                             : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); }
            ,onClickRowClick                            : function(index, data){ huit_neuf_this.onClickRowClick(index); return true; }
        };
    }

    public getViewModelForRequest(){

        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
            esp: this.getTemplateViewModel().selectedEsp(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        return super.build(classesToAdd);
    }

    //build the date Picker calendar
    public buildDatePickerCalendar(){

        this.datesFilter.buildCalendar();
    }

    public setBrandFilterItems(departments){

        let groups = [];
        for ( let department of departments){

            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }

        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel("Brands");
    }

    public setNewsletterData(newsletterData){

        this.getTemplateViewModel().newsletterData(newsletterData);
    }

    public setNewsletterTotalData(newsletterTotalData){

        this.getTemplateViewModel().newsletterTotalData(newsletterTotalData);
    }

    public setTotalSubscribers($totalSubscribers){

        this.getTemplateViewModel().totalSubscribers();
        this.getTemplateViewModel().totalSubscribers($totalSubscribers);
    }

    public formatNumber(value): string {
        if (value === null || typeof value === 'undefined' || value === '') {
            return '-';
        }

        return Number(value).toLocaleString('en-EG', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    }

    public formatPercent(value): string {
        if (value === null || typeof value === 'undefined' || value === '') {
            return '-';
        }

        return Number(value).toLocaleString('en-EG', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }) + '%';
    }

    public onClickReorder(value, data, event){

        if(typeof data.orderBy === 'undefined'){
            data = this.getTemplateViewModel();
        }
        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection() === null || data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    /**
     * @inheritDoc
     */
    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['brands']);
        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);
        if (params['esp']) {
            this.getTemplateViewModel().selectedEsp(params['esp']);
        }
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/newsletterPerformance_template.ts